import { Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfirmationDialog } from '../../../../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { setItemPackageAction } from '../../../../../../../store/order/confirm-package-order/confirm-package.actions';

@Component({
  selector: 'app-drop-from-order-confirm',
  standalone: true,
  imports: [ConfirmationDialog],
  templateUrl: './drop-from-order-confirm.html',
})
export class DropFromOrderConfirm {
  private locale = inject(LOCALE_ID);
  private store = inject(Store);

  isArabic = computed(() => this.locale.startsWith('ar'));

  itemId = input.required<string>();
  itemType = input<'product' | 'bundle'>('product');

  closed = output<void>();
  dropped = output<void>();

  isLoading = signal(false);

  onCancel() {
    this.closed.emit();
  }

  onSubmit() {
    this.store.dispatch(
      setItemPackageAction({
        itemId: this.itemId(),
        itemType: this.itemType(),
        action: 'DROP',
      }),
    );
    this.dropped.emit();
    this.closed.emit();
  }
}
